// return empty view for web, because AppIntroSlider is not supported for web
import { Fragment as AppIntroSlider } from 'react';

export default AppIntroSlider;